import React from "react";
import { FaWhatsapp } from "react-icons/fa"; // install with: npm install react-icons

const WhatsAppButton = () => {
  const phoneNumber = "+919654335152"; // Replace with your full phone number including country code (e.g., 91 for India)

  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}`, "_blank");
  };

  return (
    <div style={styles.floatingButton} onClick={handleClick}>
      <FaWhatsapp size={32} color="#fff" />
    </div>
  );
};

const styles = {
  floatingButton: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    backgroundColor: "#25D366",
    color: "white",
    borderRadius: "50%",
    width: "60px",
    height: "60px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0px 4px 6px rgba(0,0,0,0.3)",
    cursor: "pointer",
    zIndex: 1000,
  },
};

export default WhatsAppButton;
